import { useQuery } from "@tanstack/react-query";
import { TransferAvailableResponse } from "../types/transfer.types";
import { getTransferAvailable } from "../actions/get-transfer-available";

interface Params {
    companyId?: string | number | null;
    enabled?: boolean;
}

export const useTransferAvailableQuery = ({
    companyId,
    enabled = true,
}: Params) => {
    const isEnabled = enabled && !!companyId;

    return useQuery<TransferAvailableResponse>({
        queryKey: ["transfer-available-agents", String(companyId)],
        queryFn: () => getTransferAvailable(String(companyId)),
        enabled: isEnabled,
        staleTime: 0,
        refetchInterval: isEnabled ? 3000 : false,
        refetchIntervalInBackground: false,
        refetchOnWindowFocus: false,
    });
};